<template>
  <j-modal
    :title="title"
    :width="modelStyle.width"
    :visible="visible"
    :bodyStyle ="bodyStyle"
    :switchFullscreen="switchFullscreen"
    @cancel="handleCancel"
    @setInnerFullscreen="setInnerFullscreen"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel">{{language['common.closeButton']}}</a-button>
    </template>
    <a-card class="daily-article" :loading="loading">
      <a-card-meta
        :title="record.title"
        :description="language['common.creator']+'：'+(record.editor?record.editor:language['common.not']) +' | '+ language['common.createTime']+'：' + (record.createTime?record.createTime:language['common.not'])">
      </a-card-meta>
      <a-divider />
      <!--<span style="margin: 10px 0px">{{language['announcement.msgAbstract']}}:<span v-html="record.msgAbstract" class="article-content"></span></span>-->
      <span v-html="record.contentHtml" class="article-content"></span>

      <div v-if="record.imageList && record.imageList.length > 0">
        <a-divider />
        <!--<span>{{language['selfCheck.file']}}：</span>-->
        <div style="display: flex;gap: 10px;padding: 10px;flex-wrap: wrap;">
          <div v-for="file in record.imageList" :key="file.imageId" :value="file.src" @click="openFile(file.src)"
               style="display: flex;gap: 0px;padding: 10px;margin-right: 10px;background-color: rgb(107,166,215,0.16);width: 18%;cursor: pointer;">
            <!--<a  @click="announcementDownloadFile(file)">{{file.fileName}}</a>-->
            <!--<img alt="example" style="width: 100%" :src="file.src" @click="openFile(file.src)"/>-->
            <!--<a slot="actions" @click="openFile(file.src)"><a-icon type="download" />下载</a>-->
              <img  src="~@/assets/file.svg" alt="logo"  style="width: 48px;">
              <div style="display: flex;flex-direction: column;justify-content: center;font-weight: 900;font-size: 15px;width: calc(100% - 48px);" :title='file.title'>
                <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;">
                  {{file.title}}
                </span>
              </div>
          </div>
        </div>
      </div>
    </a-card>
  </j-modal>
</template>

<script>
  import {getFileAccessHttpUrl,getAction,putAction} from '@/api/manage'
  export default {
    name: "CmsDataCheckModal",
    components: {
    },
    data () {
      return {
        title:this.$store.getters.language['common.detailsButton'],
        record: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        visible: false,
        switchFullscreen: true,
        loading: false,
        bodyStyle:{
          padding: "0",
          height:(window.innerHeight*0.65)+"px",
          "overflow-y":"auto",

        },
        modelStyle:{
          width: '60%',
          style: { top: '20px' },
          fullScreen: false
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created () {
    },
    methods: {
      setInnerFullscreen(val){
        if(val){
          this.bodyStyle.height = (window.innerHeight*0.8)+'px'
        }else{
          this.bodyStyle.height = (window.innerHeight*0.65)+'px'
        }
      },
      openFile(path){
        window.open(path)
      },
      /*announcementDownloadFile(file){
        let avatarView = this.getAvatarView(file.filePath);
        window.open(avatarView)
      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.$store.getters.application.applicationCode)
      },*/
      detail (data) {
        this.visible = true;
        this.getRecord(data);
      },
      getRecord(data){
        this.record = {}
        getAction("/hhemp/CmsAPI/getCMSCheckDataDetails?langCode="+data.langCode+"&contentId="+data.contentId+"&catalogId="+data.catalogId+"&contentType="+data.contentType).then(res=>{
          if(res.success){
            this.record = res.result
            /*let list =[];
            res.result.imageList.forEach(item=>{
              list.push(item);
            })
            res.result.imageList.forEach(item=>{
              list.push(item);
            })
            res.result.imageList.forEach(item=>{
              list.push(item);
            })
            res.result.imageList.forEach(item=>{
              list.push(item);
            })
            res.result.imageList.forEach(item=>{
              list.push(item);
            })
            this.record.imageList = list*/
          }
        })
      },
      handleCancel () {
        this.visible = false;
      },
      /** 切换全屏显示 */
      handleClickToggleFullScreen() {
        let mode = !this.modelStyle.fullScreen
        if (mode) {
          this.modelStyle.width = '100%'
          this.modelStyle.style.top = '20px'
        } else {
          this.modelStyle.width = '60%'
          this.modelStyle.style.top = '50px'
        }
        this.modelStyle.fullScreen = mode
      },

    }
  }
</script>

<style lang="less">
  .announcementCustomModal{
    .ant-modal-header {
      border: none;
      display: inline-block;
      position: absolute;
      z-index: 1;
      right: 56px;
      padding: 0;
      .ant-modal-title{
        .custom-btn{
          width: 56px;
          height: 56px;
          border: none;
          box-shadow: none;
        }
      }
    }
    .daily-article{
      border-bottom: 0;
    }
  }
</style>
<style scoped lang="less">
  .daily-article {
    .article-button {
      font-size: 1.2rem !important;
    }
    .ant-card-body {
      padding: 18px !important;
    }
    .ant-card-head {
      padding: 0 1rem;
    }
    .ant-card-meta {
      margin-bottom: 1rem;
    }
    .article-content {
      p {
        word-wrap: break-word;
        word-break: break-all;
        text-overflow: initial;
        white-space: normal;
        font-size: .9rem !important;
        margin-bottom: .8rem;
      }
    }
  }
</style>
